import { BaseError } from './BaseError';

export class StoreConfigurationNotFoundError extends BaseError {
  constructor(merchantSlug: string, storefrontSlug: string) {
    super(`StoreConfiguration not found.`, {
      merchantSlug,
      storefrontSlug,
    });
  }
}
